const n = (o, r) => {
  const e = o === "before";
  let t = {};
  return t[`&::${o}`] = {
    content: '""',
    display: "block",
    position: "absolute",
    zIndex: 1,
    background: `linear-gradient(90deg, rgba(255,255,255,${e ? 1 : 0}) 0%, rgba(255,255,255,${e ? 0 : 1}) 100%)`,
    top: 0,
    width: 5,
    height: 8,
    transition: "inherit",
    animation: "inherit",
    ...e ? { left: (r == null ? void 0 : r.left) || 0 } : { right: (r == null ? void 0 : r.right) || 0 },
    ...r ?? {}
  }, t;
}, i = (o) => {
  const { before: r = !0, after: e = !0, options: t } = o;
  return {
    ...r ? n("before", t) : {},
    ...e ? n("after", t) : {}
  };
};
export {
  i as fade
};
